import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import { ApplicationTabContentFieldsFragmentDoc } from './ApplicationTabContentFragments.generated';
import { JobInfoHeaderFieldsFragmentDoc } from '../../components/__generated__/JobInfoHeaderFragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindReviewBeforeSubmitDraftQueryVariables = Types.Exact<{
    input: Types.FindReviewBeforeSubmitDraftInput;
}>;

export type FindReviewBeforeSubmitDraftQuery = {
    __typename?: 'Query';
    findReviewBeforeSubmitDraft?:
        | {
              __typename?: 'FindReviewBeforeSubmitDraftPayload';
              draft: {
                  __typename?: 'AutoApplyDraft';
                  applicationDraftId: string;
                  iaUid: string;
                  state: Types.ReviewBeforeSubmitDraftState;
                  lastPreviewId?: string | null | undefined;
                  locale: any;
                  proctors: string;
                  jobTitle: string;
                  jobLocation: string;
                  employerName?: string | null | undefined;
                  applyableJob: {
                      __typename?: 'ReviewBeforeSubmitApplyableJob';
                      jobId: string;
                      clientJobRef?: string | null | undefined;
                  };
              };
          }
        | null
        | undefined;
};

export const FindReviewBeforeSubmitDraftDocument = gql`
    query FindReviewBeforeSubmitDraft($input: FindReviewBeforeSubmitDraftInput!) {
        findReviewBeforeSubmitDraft(input: $input) {
            draft {
                ...ApplicationTabContentFields
                ...JobInfoHeaderFields
            }
        }
    }
    ${ApplicationTabContentFieldsFragmentDoc}
    ${JobInfoHeaderFieldsFragmentDoc}
`;

/**
 * __useFindReviewBeforeSubmitDraftQuery__
 *
 * To run a query within a React component, call `useFindReviewBeforeSubmitDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReviewBeforeSubmitDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReviewBeforeSubmitDraftQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindReviewBeforeSubmitDraftQuery(
    baseOptions: Apollo.QueryHookOptions<
        FindReviewBeforeSubmitDraftQuery,
        FindReviewBeforeSubmitDraftQueryVariables
    > &
        (
            | { variables: FindReviewBeforeSubmitDraftQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        FindReviewBeforeSubmitDraftQuery,
        FindReviewBeforeSubmitDraftQueryVariables
    >(FindReviewBeforeSubmitDraftDocument, options);
}
export function useFindReviewBeforeSubmitDraftLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FindReviewBeforeSubmitDraftQuery,
        FindReviewBeforeSubmitDraftQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        FindReviewBeforeSubmitDraftQuery,
        FindReviewBeforeSubmitDraftQueryVariables
    >(FindReviewBeforeSubmitDraftDocument, options);
}
export function useFindReviewBeforeSubmitDraftSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindReviewBeforeSubmitDraftQuery,
              FindReviewBeforeSubmitDraftQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        FindReviewBeforeSubmitDraftQuery,
        FindReviewBeforeSubmitDraftQueryVariables
    >(FindReviewBeforeSubmitDraftDocument, options);
}
export type FindReviewBeforeSubmitDraftQueryHookResult = ReturnType<
    typeof useFindReviewBeforeSubmitDraftQuery
>;
export type FindReviewBeforeSubmitDraftLazyQueryHookResult = ReturnType<
    typeof useFindReviewBeforeSubmitDraftLazyQuery
>;
export type FindReviewBeforeSubmitDraftSuspenseQueryHookResult = ReturnType<
    typeof useFindReviewBeforeSubmitDraftSuspenseQuery
>;
export type FindReviewBeforeSubmitDraftQueryResult = Apollo.QueryResult<
    FindReviewBeforeSubmitDraftQuery,
    FindReviewBeforeSubmitDraftQueryVariables
>;
